import React, { useEffect, useState } from "react";
import "./FlightRoute.css";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconArrowRight,
  IconCalendarEvent,
  IconPlaneArrival,
  IconPlaneDeparture,
} from "@tabler/icons-react";
export default function FlightRouteCard({ flight, handleViewMore, viewMore = true }) {
   const [timeStatus, setTimeStatus] = useState(null);
  
 
console.log(flight)
  const {
    carrier_code,
    carrier_name,
    flight_number,
    status,
    departure_airport,
    arrival_airport,
    departure_time,
    estimated_arrival,
    actual_arrival,
    arrival_time,
    departure_terminal,
    departureGate,
    arrivalGate,
    baggage,
    arrival_terminal,
    aircraft_name,
    flight_equipment_iata,
    departure_city,
    departure_country,
    arrival_city,
    arrival_country,
    region,
    operationalTimes,
    
    departure_airport_timezone,
arrival_airport_timezone

  } = flight;

  console.log(status)


  


const getTimeStatus = (actualTime, scheduledTime) => {
  const actual = new Date(actualTime).getTime();
  const scheduled = new Date(scheduledTime).getTime();

  const diffMs = actual - scheduled;
  const diffAbs = Math.abs(diffMs);

  const minutes = Math.floor(diffAbs / (1000 * 60));
  const d = Math.floor(minutes / (60 * 24));
  const h = Math.floor((minutes % (60 * 24)) / 60);
  const m = minutes % 60;

  let diffText = [];
  if (d > 0) diffText.push(`${d}d`);
  if (h > 0) diffText.push(`${h}hr`);
  if (m > 0) diffText.push(`${m}m`);
  if (diffText.length === 0) diffText.push("");

  let status = "";
  if (diffMs < 0) status = "Early";
else if (diffMs > 0) status = "Late";
else status = "On Time";

  return diffText.join(" ") + " " + status;
};

  
  function getArrivalLocalPair(times) {



    if (status === "S" || status === "Scheduled") {
       return {
        scheduled: times.scheduledGateDeparture.dateLocal,
        actual:  times.estimatedGateDeparture.dateLocal,
        type: "runway"
      };

    } 

  // 1️⃣ Gate arrival level
  if (times.scheduledGateArrival?.dateLocal) {
    const actualGateLocal =
      times.actualGateArrival?.dateLocal ||
      times.estimatedGateArrival?.dateLocal;

    if (actualGateLocal) {
      return {
        scheduled: times.scheduledGateArrival.dateLocal,
        actual: actualGateLocal,
        type: "gate"
      };
    }
  }

  // 2️⃣ Runway arrival level
  if (times.scheduledRunwayArrival?.dateLocal) {
    const actualRunwayLocal =
      times.actualRunwayArrival?.dateLocal ||
      times.estimatedRunwayArrival?.dateLocal;

    if (actualRunwayLocal) {
      return {
        scheduled: times.scheduledRunwayArrival.dateLocal,
        actual: actualRunwayLocal,
        type: "runway"
      };
    }
  }

  return null;
}

useEffect(() => {
  if (!operationalTimes) return;

 
  const pair = getArrivalLocalPair(operationalTimes);

  if (pair) {
    const status = getTimeStatus(pair.actual, pair.scheduled);
    setTimeStatus(status);
  console.log("Arrival Status:", status);
  console.log("Compared using:", pair.type);
}
}, [operationalTimes]);


 const fmt = (dt) => {
  if (!dt) return "N/A"; // null, undefined, empty, 0

  const date = new Date(dt);
  if (isNaN(date.getTime())) return "N/A"; // invalid date

  return date.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};


  const arrivalStatus = (() => {
    if (!estimated_arrival || !arrival_time) return null;
    const diff =
      new Date(estimated_arrival).getTime() - new Date(arrival_time).getTime();
    const min = Math.round(diff / 60000);
    if (min < 0) return `${Math.abs(min)} min late`;
    if (min > 0) return `${min} min early`;
    return "On time";
  })();

  function getFlightStatus(code) {
  switch (code) {
    case "A":
      return "Active (in flight)";
    case "C":
      return "Canceled";
    case "D":
      return "Diverted";
    case "DN":
      return "Data Needed / Not Available";
    case "L":
      return "Landed";
    case "NO":
      return "Not Operational";
    case "R":
      return "Redirected";
    case "S":
      return "Scheduled";
    case "U":
      return "Unknown";
    default:
      return code;
  }
}

 



  return (
    <article className="flight-card">



      


      <header className="flight-header-new">
        {
          carrier_code &&  <div className="airline-badge">{carrier_code}</div>
       }
        <div className="title">
          <h1>
            {carrier_name} • {carrier_code} {flight_number}
          </h1>
          <span className="muted">
            {aircraft_name} {
              flight_equipment_iata ? `(${flight_equipment_iata})` : ""
            } 
          </span>
        </div>

      
        
        <span className="status-chip">
          <span className="status-dot" />
           {getFlightStatus(status)}
          {timeStatus ? ` · ${timeStatus}` : ""}
        </span>
      </header>

      <section className="content">
        <div className="route">
          <div className="ap">
            {departure_airport && <div className="code">{departure_airport}</div>}
            <div className="city">
              {departure_city}, {departure_country}
            </div>
            <div className="meta">
            {departure_terminal && <span>T{departure_terminal}</span>}  
             {(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal)  && <span>{fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal )}</span>}
            </div>
            <div className="meta">
               {departureGate && <span>Gate {departureGate}</span>} {departure_airport_timezone && <span>Timezone: {departure_airport_timezone}</span>} 
            
            </div>
          </div>

          <div className="plane">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" />
            </svg>
          </div>

          <div className="ap" style={{ textAlign: "right" }}>
            <div className="code">{arrival_airport}</div>
            <div className="city">
              {arrival_city}, {arrival_country}
            </div>
            <div className="meta" style={{ justifyContent: "flex-end" }}>
             {arrival_terminal && <span>T{arrival_terminal}</span>} 
             {(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal ) && <span>{fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal )}</span> } 
            </div>

              <div className="meta" style={{ justifyContent: "flex-end" }}>
               {arrivalGate && <span>Gate {arrivalGate}</span>} {arrival_airport_timezone && <span>Timezone: {arrival_airport_timezone}</span>} 
            
            </div>
          </div>
        </div>

        <div className="details">
          <div className="flight-row">
            <div>
              <div className="label">Carrier</div>
             {carrier_name ? <div className="value">{carrier_name}</div> :"N/A"} 
            </div>
            <div>
              <div className="label">Flight #</div>
             {flight_number ?  <div className="value">{flight_number}</div>:"N/A"}
            </div>
            <div>
              <div className="label">Region</div>
             {region ? <div className="value">{region}</div> :"N/A"} 
                      </div>
                      
                        <div>
              <div className="label">Aircraft Type</div>
             {aircraft_name ?  <div className="value">{aircraft_name} {
              flight_equipment_iata ? `(${flight_equipment_iata})` : ""
            } </div>:"N/A"}
            </div>
            {/* <div>
              <div className="label">{actual_arrival ? "Actual Arrival" : "Estimated Arrival"}</div>
             {(actual_arrival || estimated_arrival) ?  <div className="value">{fmt(actual_arrival || estimated_arrival)}</div> : 'N/A'}
            </div> */}
            <div>
              <div className="label">Baggage</div>
             { baggage ? <div className="value">{baggage}</div> : "N/A"}
            </div>
          </div>

          {/* <div className="row">
          
          </div> */}
        </div>



        <div className="new-flight-timing-wrapper">
          <div style={{border:"1px solid #ddd"}}>
             <h5 className="new-flight-timing-title">
                        <IconPlaneDeparture size={'20px'} /> Departure
            </h5>
            <div className="new-flight-timing-grid">
                <div className="new-flight-timing">
              <span className="new-flight-timing-label">Scheduled Departure</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal )}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
              </div>

              {
                 (status !== "C" && status !== "DN" && status !== "S" && status !== "Scheduled" ) &&  <div className="new-flight-timing">
              <span className="new-flight-timing-label">Gate Departure</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
              </div>
              }
              
              {
                 (status === "C" || status === "DN" || status === "S" || status === "Scheduled" ) &&  <div className="new-flight-timing">
              <span className="new-flight-timing-label">Estimated Departure</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
              </div>
              }
              
              {
                (status === "A" || status === "L" || status === "D" || status === "R") &&   <div className="new-flight-timing">
              <span className="new-flight-timing-label">Takeoff</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayDeparture?.dateLocal || operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledRunwayDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
              </div>
              }
             
            </div>
           
          </div>

           <div style={{border:"1px solid #ddd"}}>
             <h5 className="new-flight-timing-title">
                        <IconPlaneArrival size={'20px'} /> Arrival
            </h5>
            <div className="new-flight-timing-grid">
               <div className="new-flight-timing">
              <span className="new-flight-timing-label">Scheduled Arrival</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal )}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
             
              </div>

              {
                (status === 'S' || status === "U" || status === "A" || status === "D" || status === "C" || status === "R" || status === "Scheduled") &&  <div className="new-flight-timing">
              <span className="new-flight-timing-label">Estimated Arrival</span>
              <span className="new-flight-timing-date">{fmt( operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
             
              </div>
              }

              {
                (status === "L" ) &&  <div className="new-flight-timing">
              <span className="new-flight-timing-label">Landing</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayArrival?.dateLocal || operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
             
              </div>
              }
              
            
              {
                 (status === "L" || status === "D" ) &&  <div className="new-flight-timing">
              <span className="new-flight-timing-label">Gate Arrival</span>
              <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal )}</span>
              {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal )}</span> */}
              </div>
               }
               
            </div>
           
          </div>
        </div>
      </section>

      
        {
        viewMore && flight?.flight_id &&<div style={{display:"flex",justifyContent:"center",margin:"10px "}}>
           <button className="view-more-btn" onClick={()=>handleViewMore(flight)}>View Flight Details </button>
          </div>
        }
    </article>
  );
}
